import {
  SET_AUTHENTICATED,
  SET_ID_SELLER,
  SET_USER_NAME,
  LIMPIAR_FILTRO,
  EDITANDO,
  RESET_OBJECT,
  SET_OBJECT,
  FETCH_LOCALIDADES,
  SET_USER_ID,
} from './types';
import { getLocalidades } from "../api/axios";

export const setObject = (object) => async dispatch => {
  dispatch({
    type: SET_OBJECT,
    payload: object
  })
}

export const resetObject = (booleanVal) => async dispatch => {
  dispatch({
    type: RESET_OBJECT,
    payload: booleanVal
  })
}

export const editando = (opciones) => async dispatch => {
  dispatch({
    type: EDITANDO,
    payload: opciones
  })
}

export const limpiarFiltros = (opciones) => async dispatch => {
  dispatch({
    type: LIMPIAR_FILTRO,
    payload: opciones
  })
}

export const setAuthenticated = (authenticationValue) => async dispatch => {
  if (typeof authenticationValue == "boolean") {
    dispatch({
      type: SET_AUTHENTICATED,
      payload: authenticationValue
    })
  }
}

export const setIdSeller = (idSeller) => async dispatch => {
  if (typeof idSeller == "number") {
    dispatch({
      type: SET_ID_SELLER,
      payload: idSeller
    })
  }
}

export const setUserId = (userId) => dispatch => {
  dispatch({
    type: SET_USER_ID,
    payload: userId
  })
}

export const setUserName = (userName) => dispatch => {
  dispatch({
    type: SET_USER_NAME,
    payload: userName
  })
}

export const fetchLocalidades = (params) => async dispatch => {
  let array = getLocalidades(params);
  array.then((value) => {
    dispatch({
      type: FETCH_LOCALIDADES,
      payload: value.elementos
    });
  })
}